import { Dispatch, SetStateAction } from "react";
import { RadioButton as RadioButtonShared } from "@src/shared/src";

interface RadioProps {
  id: string;
  name: string;
  value: string;
  setValue: Dispatch<SetStateAction<string>> | ((val: string) => void);
  checked: boolean;
  disabled?: boolean;
  labelComponent?: React.ReactNode;
}

const RadioButton = ({
  id,
  name,
  value,
  setValue,
  checked,
  disabled = false,
  labelComponent,
}: RadioProps) => {
  return (
    <>
      {/* <div className="input-radio-wrap">
        <input
          id={id}
          type="radio"
          name={name}
          className="input-radio only-sr"
          value={value}
          checked={checked}
          onChange={() => setValue(value)}
          disabled={disabled}
        />
        <label
          // htmlFor={id} // input 영역으로 스크롤 이동되는 현상 방지하기 위해 htmlFor 대신 onClick 사용
          onClick={(e) => {
            e.preventDefault();
            setValue(value);
          }}
        ></label>
      </div>
      {labelComponent && (
        <label
          className="input-radio-label"
          // htmlFor={id} // input 영역으로 스크롤 이동되는 현상 방지하기 위해 htmlFor 대신 onClick 사용
          onClick={(e) => {
            e.preventDefault();
            setValue(value);
          }}
        >
          {labelComponent}
        </label>
      )} */}
      <RadioButtonShared
        id={id}
        name={name}
        value={value}
        setValue={setValue}
        checked={checked}
        disabled={disabled}
        labelComponent={labelComponent}
        className={"input-radio-wrap"}
      />
    </>
  );
};

export default RadioButton;
